<template>
  <b-modal
    :id="id"
    hide-footer
    hide-header
    :centered="true"
    @hidden="!isCancel || $emit('close')"
  >
    <div class="py-[32px] px-[10px] flex flex-col items-center justify-center gap-[16px]">
      <slot />
      <img
        :src="`https://storage.googleapis.com/komerce/core/icon-popup-${type}.png`"
        :alt="`${type}-popup`"
        width="100"
        height="100"
      >
      <div class="text-[#333333] [&>*]:text-center flex flex-col items-center justify-center gap-[8px]">
        <b class="text-[24px]">{{ title }}</b>
        <p
          v-if="text !== ''"
          :class="{'!m-0': !cancelText}"
        >
          {{ text }}
        </p>
      </div>
      <div
        v-if="cancelText"
        class="flex gap-[12px] flex-wrap [&>*]:grow w-full"
      >
        <b-button
          :variant="`${confirmText ? 'outline-' : ''}primary`"
          @click="onClose"
        >
          {{ cancelText }}
        </b-button>
        <b-button
          v-if="confirmText"
          variant="primary"
          @click="onConfirm"
        >
          {{ confirmText }}
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
/**
 * @component GlobalModal
 * @description
 * A reusable confirmation modal component built with BootstrapVue's `<b-modal>`.
 * Provides a flexible layout with an icon, title, description text, and configurable buttons.
 *
 * Features:
 * - Centered modal with optional confirm button
 * - Supports different modal types (icon changes dynamically)
 * - Emits `confirm` and `close` events for parent handling
 * - Handles cancel/close distinction to avoid firing duplicate events
 *
 * @props {String} id - Unique ID of the modal instance (default: 'global-default-modal')
 * @props {String} type - Type of modal, determines the displayed icon (default: 'warning')
 * @props {String} title - Title text displayed in the modal header (default: 'Yakin reset berita?')
 * @props {String} text - Optional body text displayed below the title (default: '')
 * @props {String|null} confirmText - If provided, displays a confirm button with this text (default: null)
 * @props {String} cancelText - Text for the cancel button (default: 'Batalkan')
 *
 * @data {Boolean} isCancel - Internal flag to distinguish between cancel and confirm actions
 *
 * @emits close - Triggered when modal is closed manually or via cancel button
 * @emits confirm - Triggered when confirm button is clicked
 *
 * @methods
 * onConfirm() - Marks modal as confirmed, emits `confirm`, hides modal, resets state
 * onClose() - Emits `close` and hides modal
 */

export default {
  props: {
    id: {
      type: String,
      default: 'global-default-modal',
    },
    type: {
      type: String,
      default: 'warning',
    },
    title: {
      type: String,
      default: 'Yakin reset berita?',
    },
    text: {
      type: String,
      default: '',
    },
    confirmText: {
      type: String || null,
      default: null,
    },
    cancelText: {
      type: String,
      default: 'Batalkan',
    },
  },
  data() {
    return {
      isCancel: true,
    }
  },
  methods: {
    onConfirm() {
      this.isCancel = false
      this.$emit('confirm')
      this.$bvModal.hide(this.id)
      setTimeout(() => { this.isCancel = true }, 1000)
    },
    onClose() {
      this.$emit('close')
      this.$bvModal.hide(this.id)
    },
  },
}
</script>
